import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../../assets/img/logo.png";
const Home2Navbar = () => {
  return (
    <Navbar
      bg="light"
      variant="light"
      sticky="top"
      expand="lg"
      className="navbar-fixed"
      style={{ paddingLeft: "70px", paddingRight: "50px" }}
    >
      <Container fluid>
        {/* Left side - Logo */}
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="Logo"
            width="80"
            height="80"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Center - Menu Items */}
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-center">
          <Nav className="mx-auto">
            <Nav.Link href="/" className="nav-link">
              Home
            </Nav.Link>
            <Nav.Link href="/how-it-works" className="nav-link">
              How It Works
            </Nav.Link>
            <Nav.Link href="/counselors" className="nav-link">
              Counselors
            </Nav.Link>
            <Nav.Link href="/become-a-counselor" className="nav-link">
              Become a Counselor
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        {/* Right side - Buttons */}
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            <Nav.Link
              className="btn btn-sm btn-custom btn-book-session-custom"
              style={{
                backgroundColor: "#080c77", // Overridden by custom style
                borderColor: "#080c77", // Overridden by custom style
                color: "#fff",
              }}
              href="/create-account"
              id="NavButtons"
            >
              Book Appointment
            </Nav.Link>
            &nbsp;&nbsp;
            <Nav.Link
              className="btn btn-sm btn-custom btn-join-counselor-custom"
              style={{
                backgroundColor: "#de0f3f", // Overridden by custom style
                borderColor: "#de0f3f", // Overridden by custom style
                color: "#fff",
              }}
              href="/login"
              id="NavButtons"
            >
              Login
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
export default Home2Navbar;
